import * as React from "react";
import { useL10nContext } from "../../../../util/contexts";
import { EyeCatcherTypeEnum } from "../../../../types/article-price";
import "./eye-catcher.scss";

const EyeCatcher = (props: { discountPercentage: number; eyeCatherType: EyeCatcherTypeEnum }) => {
    const { decodeEyeCatcherL10n } = useL10nContext();
    const eyeCatcherL10n = decodeEyeCatcherL10n();

    const saleLabel = (discountPercentage: number) => {
        if (props.eyeCatherType === EyeCatcherTypeEnum.Sale) {
            return `${eyeCatcherL10n.sale} ${discountPercentage}%`;
        } else if (props.eyeCatherType === EyeCatcherTypeEnum.SetPrice) {
            return `${eyeCatcherL10n.setPrice} -${discountPercentage}%`;
        } else return "";
    };

    return (
        <div className="eye-catcher-wrapper">
            <div className="eye-catcher">
                <span className="inner-text"> {saleLabel(props.discountPercentage)}</span>
            </div>
        </div>
    );
};

export default EyeCatcher;
